"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));
var _react = _interopRequireWildcard(require("react"));
var _SubNavElementLinkMenuModule = _interopRequireDefault(require("./SubNavElementLinkMenu.module.css"));
var _SubNavContext = require("../../context/SubNavContext.js");
var _EventPreventionWrapper = require("../EventPreventionWrapper/EventPreventionWrapper.js");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SubNavElementLinkMenu = _ref => {
  let {
    onBlur,
    links
  } = _ref;
  const {
    MenuItemComponent,
    tenant,
    trackMenuInteraction
  } = (0, _react.useContext)(_SubNavContext.SubNavContext);
  const linkStyleClasses = [_SubNavElementLinkMenuModule.default.subNavElementLinkMenu__item__link];
  if (tenant === 'ww') {
    linkStyleClasses.push(_SubNavElementLinkMenuModule.default.subNavElementLinkMenu__item__link__ww);
  }
  const onClickHandler = selection => {
    trackMenuInteraction === null || trackMenuInteraction === void 0 || trackMenuInteraction(selection);
  };
  return /*#__PURE__*/_react.default.createElement(_EventPreventionWrapper.EventPreventionWrapper, {
    onBlur: onBlur,
    "data-testid": "SubNavElementLinkMenu"
  }, /*#__PURE__*/_react.default.createElement("nav", {
    className: _SubNavElementLinkMenuModule.default.subNavElementLinkMenu__container
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: _SubNavElementLinkMenuModule.default.subNavElementLinkMenu__content
  }, (0, _map.default)(links).call(links, link => /*#__PURE__*/_react.default.createElement("li", {
    key: link.text,
    className: _SubNavElementLinkMenuModule.default.subNavElementLinkMenu__item
  }, /*#__PURE__*/_react.default.createElement(MenuItemComponent, {
    href: link.href,
    target: link.target,
    className: linkStyleClasses.join(' '),
    "data-testid": link.text,
    onClick: () => onClickHandler(link.text)
  }, /*#__PURE__*/_react.default.createElement("span", null, link.text), !!link.badge && /*#__PURE__*/_react.default.createElement("span", {
    className: `${_SubNavElementLinkMenuModule.default.subNavElementLinkMenu__badge} ${_SubNavElementLinkMenuModule.default.subNavElementLinkMenu__badge}${link.badgeType}`
  }, link.badge)))))));
};
var _default = exports.default = SubNavElementLinkMenu;